import { Observable } from 'rxjs';
import { FusionApiHttpClient } from '../../shared/_services/server-clients';

export class DealsApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  deleteDeal(pubDealId: number): Observable<void> {
    return this.fusionApiHttpClient.plain.delete<void>(`deal/${pubDealId}`);
  }
}
